import { useCallback, useEffect, useState } from 'react';
// Import Hooks
import useRequest from './UseRequest';
import useCancelableRequests from './UseCancelableRequests';
// Import Services
import { PromotionHttpService } from 'services/http';

export const useMetricsList = () => {
    const { doGetRequest } = useRequest();
    const [metricsMap, setMetricsMap] = useState<Record<number, string>>({});
    const [isMetricsLoading, setIsMetricsLoading] = useState(false);

    const { getPromotionEfficiencyMetricsRequest } = useCancelableRequests({
        getPromotionEfficiencyMetricsRequest: PromotionHttpService.getPromotionEfficiencyMetrics,
    });

    const getEfficiencyMetrics = useCallback(() => {
        setIsMetricsLoading(true);
        doGetRequest(getPromotionEfficiencyMetricsRequest.request, {
            successCallback: (data) => {
                const map = data.reduce((acc, item) => {
                    acc[item.Id] = item.Name;
                    return acc;
                }, {});
                setMetricsMap(map);
            },
        }).finally(() => {
            setIsMetricsLoading(false);
        });
    }, [doGetRequest, getPromotionEfficiencyMetricsRequest]);

    useEffect(() => {
        getEfficiencyMetrics();
    }, [getEfficiencyMetrics]);

    return {
        isMetricsLoading,
        metricsMap,
    };
};
